<span class="doughnut--centering">
  <span
    class="immutable-chartjs-style"
    [style.height.px]="size"
    [style.width.px]="size"
  >
    <canvas
      baseChart
      [type]="_chartType"
      [data]="_data"
      [options]="_options"
      [plugins]="plugins"
    >
    </canvas>
  </span>
</span>

@if (displayLegend && _legendItems) {
  <myre-chart-legend
    [items]="_legendItems"
    [chart]="_chartDirective?.chart"
    [canToggleDataVisibility]="canToggleDataVisibility"
    modeLinkingHover="singleDataset"
  />
}
